import { produce } from 'immer';

import { SelectOneImageInternalInGallery } from '../../../actions/imageEditor/internal/selectOneImageInternalInGallery';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageEditorsState } from '../../../typings/state';

export function selectOneImageInternalInGallery(
    state: ImageEditorsState,
    action: SelectOneImageInternalInGallery
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].imageGallery.selectedImageHashFromGallery = [action.imageHash];
    });
}
